import { useState } from "react";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Space } from "../../services/coworkerApiCalls/Space/SpacesTypes";
import { SpaceEdit } from "../../components/spaces/space";

const AddSpace: React.FC = () => {
    const [space] = useState<Space>({
        id: 0,
        name: '',
        city: '',
        address: '',
        postCode: 0,
        charterId: undefined,
        informationId: undefined,
        quotas: []
    });

    return (
        <div>
            <SpaceEdit {...space}></SpaceEdit>
        </div>
    );
};

export { AddSpace };